/*
 *  Copyright
 *
 *  Tegona S.A.
 *
 *  Tegona JS © 2017, Tegona S.A.
 *
 *  ALL RIGHTS RESERVED. THIS PROGRAM CONTAINS MATERIAL PROTECTED
 *  UNDER INTERNATIONAL AND SWITZERLAND COPYRIGHT LAWS AND TREATIES.
 *  ANY UNAUTHORIZED USE OF THE PROGRAM, INCLUDING REPRODUCTION,
 *  MODIFICATION, TRANSFER, TRANSMITTAL OR REPUBLICATION OF THIS
 *  MATERIAL IN ANY FORM OR BY ANY MEANS IS PROHIBITED WITHOUT
 *  SPECIFIC WRITTEN PERMISSION OF THE COPYRIGHT HOLDER.
 *
 *  copyright@tegona.com
*/

import React from 'react'
import autoBind from 'react-autobind'
import { withRouter } from 'react-router-dom'
import { injectIntl } from 'react-intl'
import { Checkbox } from 'material-ui'
import { red500, deepOrange500, green500 } from 'material-ui/styles/colors'

import * as constants from 'constants/Prestation'

class InterpreterSearchBottom extends React.Component {

  constructor(props) {
    super(props)
    autoBind(this)
  }

  handleConfirmAutoChange(event, value) {
    const promise = new Promise( (resolve, reject) => {
      resolve(this.props.handleChange(event, value))
    })

    promise.then(() => {
      this.props.handlePrestationChange('interpreter', {uid: value ? this.props.prestation.choosenInterpreter : undefined})
    })
  }

  render() {
    const prestation = this.props.prestation

    return (
      <div className='row'>
        {
          !prestation.uid &&
          this.props.isStaff &&
          this.props.isPastPrestation &&
          !prestation.choosenInterpreter
            ? <div
              className='col-md-12 col-xs-12'
              style={{
                color: red500,
                textAlign: 'center',
                paddingTop: 20,
                ...styles.fontText,
              }}
            >
              {this.props.intl.formatMessage(constants.messages.MISSING_INTERPRETER_LABEL_ERROR)}
            </div>
            : undefined
        }

        {
          !this.props.isStaff &&
          this.props.isPastPrestation
            ? <div
              className='col-md-12 col-xs-12'
              style={{
                color: red500,
                textAlign: 'center',
                paddingTop: 20,
                ...styles.fontText,
              }}
            >
              {this.props.intl.formatMessage(constants.messages.PAST_PRESTATION_LABEL_ERROR)}
            </div>
            : undefined
        }

        {
          this.props.similarPrestation
            ? <div
              className='col-md-12 col-xs-12'
              style={{
                color: deepOrange500,
                textAlign: 'center',
                paddingTop: 20,
                ...styles.fontText,
              }}
            >
              <u>{this.props.intl.formatMessage(constants.messages.CARREFUL_SIMILAR_PRESTATION_EXIST)}</u>
              {this.props.intl.formatMessage(constants.messages.SIMILAR_PRESTATION_EXIST)} {this.props.similarPrestation}): <u>{this.props.intl.formatMessage(constants.messages.CONFIRM_SIMILAR_PRESTATION_EXIST)}</u>
            </div>
            : undefined
        }

        {
          this.props.isStaff &&
          prestation.choosenInterpreter &&
          this.props.isPastPrestation
          ? <div
            className='col-md-12 col-xs-12'
          >
            <Checkbox
              name='validation'
              style={{paddingTop: 20, maxWidth: 373}}
              labelStyle={{
                color: deepOrange500,
                ...styles.fontText
              }}
              label={this.props.intl.formatMessage(constants.messages.VALIDATION_LABEL)}
              checked={prestation.validation}
              onCheck={this.props.handleChange}
              inputStyle={styles.fontText}
            />
          </div>
          : undefined
        }

        {
          this.props.isStaff &&
          prestation.choosenInterpreter &&
          prestation.ordered_start_time &&
          prestation.ordered_end_time &&
          !this.props.isPastPrestation
          ? <div
            className='col-md-12 col-xs-12'
          >
            <Checkbox
              name='confirmAuto'
              style={{paddingTop: 20, maxWidth: 392}}
              labelStyle={{
                color: green500,
                ...styles.fontText
              }}
              label={this.props.intl.formatMessage(constants.messages.CONFIRM_AUTO_LABEL)}
              checked={prestation.confirmAuto}
              onCheck={this.handleConfirmAutoChange}
            />
          </div>
          : undefined
        }
      </div>
    )
  }
}

const styles = {
  fontText: {
    fontSize: 14
  },
}

export default withRouter(
  injectIntl(InterpreterSearchBottom)
)



// WEBPACK FOOTER //
// ./src/components/applicant/prestation/creation/search/InterpreterSearchBottom.js